export const titleOptions = ['', 'titleDr', 'titleProfDr'];
